// extracted by mini-css-extract-plugin
module.exports = {"container":"DimensionTree_container__34Nx4","addButton":"DimensionTree_addButton__1HBoX"};